import { pairing } from '@bedrock-rdk/config';
import {
  PAIRING_FETCH_STATUS_SUCCESS,
  PAIRING_FETCH_TOKEN_SUCCESS,
  PAIRING_FETCH_USER_SUCCESS,
  PAIRING_LOGOUT_SUCCESS,
  PAIRING_SET_PARENTAL_LOCK_STATUS,
  SET_SUBSCRIPTIONS,
  PAIRING_SET_UNPAIRED_ENTERING,
  PAIRING_CLEAR_UNPAIRED_ENTERING,
  RENEW_TOKEN_SUCCESS,
  CLEAR_USER_PROFILE,
  SELECT_USER_PROFILE,
  PAIRING_SET_POLLING_INTERVAL,
  PAIRING_INCREMENT_POLLING_INTERVAL,
  PAIRING_CLEAR_TOKEN,
} from './pairing.actions';
import { STATUS_PAIRED } from './pairing.utils';
import { PAIRING_RESET } from './unpair.actions';

const initialState = {
  token: null,
  verificationURI: null,
  status: null,
  email: '',
  subscriptions: null,
  catalogAccess: null,
  photoUrl: null,
  firstname: '',
  lastname: '',
  parentalControl: null,
  isUnpairedEntering: false,
  profileUid: null,
  // NOTE: This value represents explicit manual profile selection
  selectedProfileUid: null,
  pollingInterval: pairing.pairingPollInterval,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PAIRING_SET_POLLING_INTERVAL: {
      return {
        ...state,
        pollingInterval: action.pollingInterval,
      };
    }
    case PAIRING_INCREMENT_POLLING_INTERVAL: {
      return {
        ...state,
        pollingInterval: (state.pollingInterval || initialState.pollingInterval) + 5000,
      };
    }
    case PAIRING_SET_PARENTAL_LOCK_STATUS:
      return {
        ...state,
        parentalControl: action.parentalControlStatus,
      };
    case PAIRING_FETCH_TOKEN_SUCCESS:
      return {
        ...state,
        token: action.token,
        verificationURI: action.verificationURI,
      };
    case PAIRING_CLEAR_TOKEN:
      return {
        ...state,
        token: null,
        verificationURI: null,
      };
    case PAIRING_FETCH_STATUS_SUCCESS:
      return {
        ...state,
        status: action.status,
      };
    case PAIRING_FETCH_USER_SUCCESS:
      return {
        ...state,
        ...action.user,
        status: STATUS_PAIRED,
      };
    case SET_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptions: action.subscriptions,
      };
    case PAIRING_LOGOUT_SUCCESS:
      return {
        ...initialState,
        isUnpairedEntering: state.isUnpairedEntering,
      };
    case RENEW_TOKEN_SUCCESS:
      return {
        ...state,
        profileUid: action.profileUid,
      };
    case SELECT_USER_PROFILE:
      return {
        ...state,
        selectedProfileUid: action.profileUid,
      };
    case CLEAR_USER_PROFILE:
      return {
        ...state,
        profileUid: null,
        selectedProfileUid: null,
      };
    case PAIRING_SET_UNPAIRED_ENTERING:
      return {
        ...state,
        isUnpairedEntering: true,
      };
    case PAIRING_CLEAR_UNPAIRED_ENTERING:
      return {
        ...state,
        isUnpairedEntering: false,
      };
    case PAIRING_RESET: {
      return initialState;
    }
    default:
      return state;
  }
};
